// extracted by mini-css-extract-plugin
module.exports = {"ad":"BreedfiAd_ad__1R_gj","cyberdogzAd":"BreedfiAd_cyberdogzAd__1DlK2"};